import { styled } from "@mui/material/styles";
import type { Theme } from "@mui/material/styles/createTheme";
import type { SxProps } from "@mui/system/styleFunctionSx";
import React, { MouseEventHandler, type FC, type ReactNode } from "react";

interface ClickablePillProps {
  children?: ReactNode;
  style?: object;
  sx?: SxProps<Theme>;
  onClick?: MouseEventHandler<HTMLSpanElement>
  active?: boolean
}

interface SeverityPillRootProps {
  ownerState: {
    active: boolean
  };
  onClick?: MouseEventHandler<HTMLSpanElement>
}

const SeverityPillRoot = styled("span")<SeverityPillRootProps>(
  ({ theme, ownerState }) => {
    const backgroundColor = ownerState.active ? theme.palette['primary'].main : theme.palette['primary'].alpha8
    const color = ownerState.active ? 'white' : theme.palette['primary'].alpha50

    return {
      alignItems: "center",
      backgroundColor,
      borderRadius: 18,
      color,
      cursor: "default",
      display: "inline-flex",
      flexGrow: 0,
      flexShrink: 0,
      fontFamily: theme.typography.fontFamily,
      fontSize: theme.typography.pxToRem(12),
      lineHeight: 2,
      height: 36,
      fontWeight: 600,
      justifyContent: "center",
      letterSpacing: 0.5,
      minWidth: 20,
      paddingLeft: 12,
      paddingRight: 12,
      paddingTop: 4,
      paddingBottom: 4,
      textTransform: "uppercase",
      whiteSpace: "nowrap",
      userSelect: 'none',
      ":hover": {
        cursor: 'pointer',
        backgroundColor: ownerState.active ? theme.palette['primary'].main : theme.palette['primary'].alpha12
      }
    };
  },
);

export const ClickablePill: FC<ClickablePillProps> = (props) => {
  const { children, active, ...other } = props;

  const ownerState = { active: !!active };

  return (
    <SeverityPillRoot ownerState={ownerState} {...other}>
      {children}
    </SeverityPillRoot>
  );
};